import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: 'school/school-list',
        data,
        method: 'post'
    })
};
// 操作
export const operate = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: 'school/apply',
        data,
        method: 'post'
    })
};
// 删除
export const setDel = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/school/school-delete',
        data,
        method: 'post'
    })
};
// 获取详情
export const fetchInfo = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: 'school/school-info',
        data,
        method: 'post'
    })
};
// 代理修改
export const modifyProxy = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/school/proxy-update',
        data,
        method: 'post'
    })
};
// 充值
export const setRecharge = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/school/change-school-money',
        data,
        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/school/school-status',
        data,
        method: 'post'
    })
};
export const addModify = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/school/school-update',
        data,
        method: 'post'
    })
};